export default __webpack_public_path__ + "static/media/valleyPort6.804cedd3.png";